export default __webpack_public_path__ + "static/media/astraylia.97dd5c3f.svg";